module.exports = require("./de-LI.js");